import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Search from "@/pages/Search";
import TeacherDetail from "@/pages/TeacherDetail";
import TeacherDashboard from "@/pages/TeacherDashboard";
import ParentDashboard from "@/pages/ParentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import TeacherPerformance from "@/pages/TeacherPerformance";
import MentorReviews from "@/pages/MentorReviews";
import StudentPerformance from "@/pages/StudentPerformance";
import ShareView from "@/pages/ShareView";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Pricing from "@/pages/Pricing";
import Landing from "@/pages/Landing";
import MentorAnalytics from "@/pages/MentorAnalytics";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/search" element={<Search />} />
            <Route path="/teacher/:id" element={<TeacherDetail />} />
            <Route path="/teacher/:id/performance" element={<TeacherPerformance />} />
            <Route path="/teacher/:id/reviews" element={<MentorReviews />} />
            <Route path="/parent/students/:childId/performance" element={<StudentPerformance />} />
            <Route path="/share/:token" element={<ShareView />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route
              path="/teacher/dashboard"
              element={
                <ProtectedRoute role="teacher">
                  <TeacherDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mentor/analytics"
              element={
                <ProtectedRoute role="teacher">
                  <MentorAnalytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parent/dashboard"
              element={
                <ProtectedRoute role="parent">
                  <ParentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
          <Toaster
            richColors
            position="top-right"
            toastOptions={{
              style: { background: "#FFF7ED", color: "#13A699", border: "1px solid #13A69922" },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
